import { Link, useSearchParams } from "react-router-dom";

const GearListGridView = ({ gears }) => {
  const [searchParams] = useSearchParams();

  let params = {};
  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  console.log("params", params);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-6 p-6">
      {gears.map((gear) => (
        <Link
          key={gear.id}
          to={`${gear.id}?${new URLSearchParams(params).toString()}`}
          className="block text-center"
        >
          {gear.image ? (
            <img
              className="w-full aspect-square rounded-2xl object-contain border border-gray-100 dark:border-gray-700"
              src={gear.image.thumb}
            />
          ) : (
            <div className="w-full aspect-square bg-gray-200 dark:bg-gray-700 rounded-2xl"></div>
          )}

          <div className="pt-2">{gear.name}</div>
        </Link>
      ))}
    </div>
  );
};

export default GearListGridView;
